import React, { useState, useEffect } from 'react';
import Navbar from '../Components/NavBar';
import Footer from '../Components/Footer.js';
import AboutOne from './AboutOne.js';
import AboutTwo from './AboutTwo.jsx';
import AboutThree from './AboutThree.jsx';
import AboutFour from './AboutFour.jsx';
import AboutFive from './AboutFive.jsx';
import AboutSix from './AboutSix.jsx';


const AboutUsMain = () => {


  return (
    <>
      <Navbar />
      <AboutOne />
      <AboutTwo />
      <AboutThree />
      <AboutFour />
      <AboutFive />
      <AboutSix />
      <Footer />
    </>

  );
};

export default AboutUsMain;
